import { Pagination } from 'react-bootstrap'
import React from 'react'
import { t } from 'ttag'
import isNil from 'lodash/isNil'

import { extractIdsFromListingForType } from './actions/journals'

export const monthNames = [
  t`January`,
  t`February`,
  t`March`,
  t`April`,
  t`May`,
  t`June`,
  t`July`,
  t`August`,
  t`September`,
  t`October`,
  t`November`,
  t`December`
]

export const condenseSmall = (d, minV) => {
  const minVal = minV || 5
  const total = d.reduce((a, cv) => {
    return a + cv.value
  }, 0)
  const filtered = d.filter(v => 100 * (v.value / total) >= minVal)
  const filteredTotal = filtered.reduce((a, cv) => {
    return a + cv.value
  }, 0)

  console.log(d, total, filtered, filteredTotal)

  if (total - filteredTotal > 0) {
    return [
      ...filtered,
      {
        name: 'Other',
        value: total - filteredTotal
      }
    ]
  }

  return filtered
}

export const numWordsInString = s => {
  const str = (stripHtmlTagsFromString(s, true) || '')
    .replace(/\&nbsp\;/g, ' ')
    .replace(/\s\s+/g, ' ')

  if (!str || str.trim().length == 0) {
    return 0
  }

  const itms = str.trim().split(' ')
  //console.log(str)
  const fullWords = itms.length - 1

  return fullWords + (itms[fullWords].length == 0 ? 0 : 1)
}

export const trackOutboundLink = url => {
  ga('send', 'event', 'outbound', 'click', url, {
    transport: 'beacon',
    hitCallback() {
      console.log('SENDING')
      window.location.href = url
    }
  })
}

export const trackOutboundJobApplication = (url, redirect) => {
  ga('send', 'event', 'jobopenings', 'apply', url, {
    transport: 'beacon',
    hitCallback() {
      document.location = redirect
    }
  })
}

export const generateClassName = inp => {
  const cn = new String(inp)
  const replaced = cn.replace(/\./g, '-')

  console.log(cn, replaced)

  return replaced
}

//Must have a personalization section, that is standardized to make this shortcut
export const handleReducingJournalForItem = (action, state, profileKey) => {
  //console.log("STARTING FIRST")
  const newJs = extractIdsFromListingForType(
    action.journals,
    action.objectId,
    action.objectTypeId
  )

  return {
    ...state,
    [profileKey]: {
      ...state[profileKey],
      personalization: {
        ...state[profileKey]?.personalization,
        journals: newJs
      }
    }
  }
}

export const listStatesInUS = () => {
  return [
    {
      id: 'AL',
      label: t`Alabama`
    },
    {
      id: 'AK',
      label: t`Alaska`
    },
    {
      id: 'AZ',
      label: t`Arizona`
    },
    {
      id: 'AR',
      label: t`Arkansas`
    },
    {
      id: 'CA',
      label: t`California`
    },
    {
      id: 'CO',
      label: t`Colorado`
    },
    {
      id: 'CT',
      label: t`Connecticut`
    },
    {
      id: 'DE',
      label: t`Delaware`
    },
    {
      id: 'DC',
      label: t`Washington D.C.`
    },
    {
      id: 'FL',
      label: t`Florida`
    },
    {
      id: 'GA',
      label: t`Georgia`
    },
    {
      id: 'HI',
      label: t`Hawaii`
    },
    {
      id: 'ID',
      label: t`Idaho`
    },
    {
      id: 'IL',
      label: t`Illinois`
    },
    {
      id: 'IN',
      label: t`Indiana`
    },
    {
      id: 'IA',
      label: t`Iowa`
    },
    {
      id: 'KS',
      label: t`Kansas`
    },
    {
      id: 'KY',
      label: t`Kentucky`
    },
    {
      id: 'LA',
      label: t`Louisiana`
    },
    {
      id: 'ME',
      label: t`Maine`
    },
    {
      id: 'MD',
      label: t`Maryland`
    },
    {
      id: 'MA',
      label: t`Massachusetts`
    },
    {
      id: 'MI',
      label: t`Michigan`
    },
    {
      id: 'MN',
      label: t`Minnesota`
    },
    {
      id: 'MS',
      label: t`Mississippi`
    },
    {
      id: 'MO',
      label: t`Missouri`
    },
    {
      id: 'MT',
      label: t`Montana`
    },
    {
      id: 'NE',
      label: t`Nebraska`
    },
    {
      id: 'NV',
      label: t`Nevada`
    },
    {
      id: 'NH',
      label: t`New Hampshire`
    },
    {
      id: 'NJ',
      label: t`New Jersey`
    },
    {
      id: 'NM',
      label: t`New Mexico`
    },
    {
      id: 'NY',
      label: t`New York`
    },
    {
      id: 'NC',
      label: t`North Carolina`
    },
    {
      id: 'ND',
      label: t`North Dakota`
    },
    {
      id: 'OH',
      label: t`Ohio`
    },
    {
      id: 'OK',
      label: t`Oklahoma`
    },
    {
      id: 'OR',
      label: t`Oregon`
    },
    {
      id: 'PA',
      label: t`Pennsylvania`
    },
    {
      id: 'PR',
      label: t`Puerto Rico`
    },
    {
      id: 'RI',
      label: t`Rhode Island`
    },
    {
      id: 'SC',
      label: t`South Carolina`
    },
    {
      id: 'SD',
      label: t`South Dakota`
    },
    {
      id: 'TN',
      label: t`Tennessee`
    },
    {
      id: 'TX',
      label: t`Texas`
    },
    {
      id: 'UT',
      label: t`Utah`
    },
    {
      id: 'VT',
      label: t`Vermont`
    },
    {
      id: 'VA',
      label: t`Virginia`
    },
    {
      id: 'VI',
      label: t`Virgin Islands`
    },
    {
      id: 'WA',
      label: t`Washington`
    },
    {
      id: 'WV',
      label: t`West Virginia`
    },
    {
      id: 'WI',
      label: t`Wisconsin`
    },
    {
      id: 'WY',
      label: t`Wyoming`
    }
  ]
}

export const stripHtmlTagsFromString = (str, spaceBetween = false) => {
  if (isNil(str) || str === '') {
    return str
  }

  const replaceChar = spaceBetween ? ' ' : ''

  return str.toString().replace(/(<([^>]+)>)/gi, replaceChar)
}

export const generatePagination = (pagination, onPageChange) => {
  const maxPages = 6
  const itemValArray = () => {
    let minVal = 1
    let maxVal = Math.min(pagination.pages, maxPages)

    if (pagination.pages >= maxPages) {
      maxVal = pagination.current + maxPages / 2
      minVal = pagination.current - maxPages / 2

      if (maxVal > pagination.pages) {
        const diff = Math.abs(maxVal - pagination.pages)

        maxVal = pagination.pages
        minVal -= diff
      } else if (minVal < 1) {
        const diff = Math.abs(1 - minVal)

        minVal = 1
        maxVal += diff
      }
    }

    const itemVals = []

    //console.log(pagination, minVal, maxVal)
    for (let i = minVal; i <= maxVal; i++) {
      itemVals.push(i)
    }

    return itemVals
  }
  const minStart = pagination.current - Math.max(0, Math.min(3, 3 - pagination.current))
  const min = Math.max(1, pagination.current - 3)
  const max = Math.min(pagination.pages, pagination.current + 3)
  const firstProps = {}

  if (pagination.current == 1) {
    firstProps.disabled = true
  }

  const lastProps = {}

  if (pagination.current == pagination.pages) {
    lastProps.disabled = true
  }

  const genProps = itm => {
    return itm === pagination.current ? { active: true } : {}
  }

  return (
    <Pagination>
      <Pagination.First onClick={() => onPageChange(1)} {...firstProps} />
      <Pagination.Prev
        onClick={() => onPageChange(Math.max(1, pagination.current - 1))}
        {...firstProps}
      />
      {itemValArray().map(idx => (
        <Pagination.Item {...genProps(idx)} onClick={() => onPageChange(idx)}>
          {idx}
        </Pagination.Item>
      ))}
      <Pagination.Next
        onClick={() => onPageChange(Math.min(pagination.pages, pagination.current + 1))}
        {...lastProps}
      />
      <Pagination.Last onClick={() => onPageChange(pagination.pages)} {...lastProps} />
    </Pagination>
  )
}

export const scrollToTopOfScreen = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  })
}
